import { useState } from 'react';

import styles from './Toggle.module.scss';

interface ToogleProps {
  /** If `true`, the toggle will be `ON`/`enabled` */
  state: boolean;
  label?: string;
  id?: string;
  disabled?: boolean;
  onChange?: (isChecked: boolean, event: React.ChangeEvent<HTMLInputElement>, itemId?: string) => void;
  onClick?: (event?: React.MouseEvent) => void;
}

const Toggle: React.FC<React.PropsWithChildren<ToogleProps>> = ({
  state,
  label,
  id,
  disabled = false,
  onChange,
  onClick,
}) => {
  const ContainerComponent = label ? 'label' : 'div';
  const [focused, setFocused] = useState(false);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    // This is done since browsers do not fire onClick mouse events when the HTML element is disabled.
    // Read more here: https://stackoverflow.com/a/3100395
    if (!disabled) {
      onChange?.(event.target.checked, event, id);
    } else {
      event.preventDefault();
    }
  };

  return (
    <ContainerComponent className={styles['toggle']} data-disabled={disabled} data-active={state}>
      <span className={styles['toggle-input']}>
        <input
          type="checkbox"
          checked={state}
          onChange={(event) => {
            onChangeHandler(event);
          }}
          onClick={(event) => {
            onClick?.(event);
          }}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          disabled={disabled}
        />
        <div className={styles['switch']} data-focus={focused}>
          <div className={styles['dot']}></div>
        </div>
      </span>
      {label && <span className={styles['toggle-label']}>{label}</span>}
    </ContainerComponent>
  );
};

export default Toggle;
